import { useBulkEditDataGridContext } from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';
import SearchDataGrid, {
  SearchDataGridProps,
} from 'components/search/search-data-grid/search-data-grid.component';
import { getRowClassName } from '../menu-management-data-grid.utils';

const MenuManagementBulkEditDataGrid = (props: SearchDataGridProps) => {
  const { setSelectedRowIds } = useBulkEditDataGridContext();

  return (
    <SearchDataGrid
      onRowSelectionModelChange={(ids: string[]) => setSelectedRowIds(ids)}
      getRowClassName={getRowClassName}
      keepNonExistentRowsSelected
      {...props}
    />
  );
};

export default MenuManagementBulkEditDataGrid;
